// Reads the logged-in user's display name the same way Nav.vue does today (Auth0's
// nickname claim, stashed in localStorage on login). Swap the body for a real
// GET /me call later — call sites only care about the returned string.
export function getCurrentUserName () {
  const username = localStorage.getItem('username')
  if (!username) return 'Unknown user'
  return username.replace(/\./g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}



// WEBPACK FOOTER //
// ./src/components/user-journey/journey-flow/currentUser.js